export default __webpack_public_path__ + "static/media/30.ede16d32.png";